import { CallToAction } from 'components/CallToAction'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import { SectionWrapper } from '../Sections'
import { ICTA } from '../ProductLayout/types'
import { prepareData } from 'utils/googleData'

export const CTA = (props: ICTA) => {
    const {
        enable,
        title,
        subtitle,
        direction,
        url,
        description,
        cta2,
        products,
        svgImage,
        gatsbyImage,
        imageStyles,
        openQuickContact,
        form,
        isSecured,
    } = prepareData({ props })
    console.log('form2312312', form)
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <SectionWrapper direction={direction}>
            <div className="flex flex-col justify-between space-y-4 rounded-lg bg-gray-accent-light p-12 dark:bg-primary md:flex-row md:items-center md:space-y-0 md:space-x-4">
                <div>
                    <h2 className="m-0">{title}</h2>
                    <p className="m-0 mb-6">{subtitle}</p>
                    <div className="flex items-center space-x-4">
                        <CallToAction to={url} openQuickContact={openQuickContact} form={form} isSecured={isSecured}>
                            {title}
                        </CallToAction>
                        {cta2?.title !== '' && (
                            <>
                                <div className="bg-gray-300 dark:bg-gray-700 h-8 w-px" />
                                <CallToAction
                                    type="secondary"
                                    to={cta2?.url}
                                    openQuickContact={cta2?.openQuickContact}
                                    form={form}
                                    isSecured={cta2?.isSecured}
                                >
                                    {cta2?.title}
                                </CallToAction>
                            </>
                        )}
                    </div>
                </div>
                {gatsbyImage && (
                    <div className="md:max-h-[200px] md:max-w-[400px]">
                        <GatsbyImage alt={title} image={gatsbyImage} />
                    </div>
                )}
                {svgImage && !gatsbyImage && (
                    <div className="md:max-w-[400px]">
                        <img alt={title} src={svgImage} />
                    </div>
                )}
            </div>
        </SectionWrapper>
    )
}

export default CTA
